import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import { connect } from "react-redux";

import ChildPanel from "./partials/child-panel/ChildPanel";

import Router from "router/router";
import * as Api from "api/api";
import * as css from "./css/goods-category";

function GoodsCategory(props) {
  const { className, app } = props;
  const { goodsCategoryList } = app;
  let history = useHistory();

  const [childCategoryList, setChildCategoryList] = useState([]);
  const [showChildPanel, setShowChildPanel] = useState(false);
  const [currentHoverCategoryId, setCurrentHoverCategoryId] = useState(-1);
  const [currentCategoryId, setCurrentCategoryId] = useState(-1);

  function toSearch({
    categoryId,
    optId,
    categoryName,
    categorySelf,
    parentId,
    level,
    isSelect,
  }) {
    // 创建地址栏参数对象
    let search = new URLSearchParams();
    if (categoryName) {
      search.append("parentCategoryId", parentId);
      search.append("categoryId", categoryId);
      search.append("categoryOptId", optId);
      search.append("categoryName", categoryName);
      search.append("categorySelf", categorySelf);
      search.append("level", level);
      search.append("isSelect", isSelect);
    }
    history.push({
      pathname: Router.Search.path,
      search:search.toString(),
    });
  }

  async function fetchChildrenCategory(parent) {
    let {
      id: parentId,
      optId: parentOptId,
      name: parentName,
      isSelf,
      hasSelf,
      icon,
      iconActive,
      isSelect,
    } = parent;

    let childList = [];

    if (isSelf) {
      let { list } = await Api.allChildGoodsCategoryList();
      if (list.length === 0) {
        list.push({
          id: parentOptId,
          name: parentName,
          isSelf,
          hasSelf,
        });
      } else {
        list = list.map((item) => {
          return {
            ...item,
            hasSelf,
          };
        });
      }
      childList.push(...list);
    } else {
      const { list } = await Api.pddGoodsCategoryListByParentId({
        parentId,
        parentOptId,
      });

      if (list.length === 0) {
        list.push({
          id: parentId,
          name: parentName,
          isSelf,
        });
      }
      childList.push(...list);
    }

    setChildCategoryList(childList);
  }

  function renderCategoryList() {
    return goodsCategoryList.map((item, i) => {
      let {
        id,
        optId,
        parentId,
        name,
        isSelf,
        icon,
        iconActive,
        level,
        isSelect,
      } = item;
      //   如果是平台自营
      if (id === 0) {
        icon = require("./img/self-category.jpg");
        iconActive = require("./img/self-category-active.jpg");
      }

      const onMouseEnter = async () => {
        setShowChildPanel(true);

        setCurrentHoverCategoryId(id);
        setCurrentCategoryId(id);
        fetchChildrenCategory({ ...item });
      };

      const onMouseLeave = () => {
        setShowChildPanel(false);
        setCurrentHoverCategoryId(-1);
      };

      return (
        <css.CategoryItemWrapper
          key={id}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          onClick={() => {
            toSearch({
              categoryId: id,
              optId,
              categoryName: name,
              categorySelf: isSelf,
              parentId,
              level,
              isSelect,
            });
          }}
        >
          {currentHoverCategoryId === id ? (
            <css.CategoryItemHover>
              <img src={iconActive} alt="" className="icon" />
              {name}
              <div className="bg-img-wrapper">
                <img
                  src={require("./img/hover-bg.png")}
                  alt=""
                  className="bg-img"
                />
              </div>
            </css.CategoryItemHover>
          ) : (
            <css.CategoryItem>
              <img src={icon} alt="" className="icon" />
              {name}
              <img
                src={require("./img/arrow-right.png")}
                alt=""
                className="more"
              />
            </css.CategoryItem>
          )}
        </css.CategoryItemWrapper>
      );
    });
  }

  return (
    <css.GoodsCategory className={className}>
      {/* bg */}
      <div className="bg-img-wrapper">
        <img src={require("./img/bg.png")} alt="" className="bg-img" />
      </div>
      <css.CategoryContainer>
        <css.CategoryItem
          className="all"
          onClick={() => {
            toSearch({});
          }}
        >
          所有分类
          <img
            src={require("./img/all-category-icon.png")}
            alt=""
            className="icon"
          />
        </css.CategoryItem>
        {renderCategoryList()}
      </css.CategoryContainer>
      {/* child panel */}

      {showChildPanel && (
        <css.ChildPanel
          // className={`${showChildPanel ? 'show' : ''}`}
          as={ChildPanel}
          childList={childCategoryList}
          onMouseEnter={(i) => {
            setShowChildPanel(true);
            setCurrentHoverCategoryId(currentCategoryId);
          }}
          onMouseLeave={() => {
            setShowChildPanel(false);
            setCurrentHoverCategoryId(-1);
          }}
        />
      )}
    </css.GoodsCategory>
  );
}

export default connect((state) => {
  const { app } = state;

  return { app };
})(GoodsCategory);
